import Omit from 'lodash/omit'
import { buildImageUrlFromRefFileName } from '@data/attachment'
import { getEncryptedPassword, getDecryptedPassword } from '@utils/password'
import { getBrandingApi, updateBrandingApi } from './api'
export const state = {
  branding: getSavedState('branding'),
}

export const getters = {
  branding(state) {
    return state.branding
  },
  logo(state) {
    return state.branding.logoSrc
  },
  darkThemeLogo(state) {
    return state.branding.darkThemeLogoSrc
  },
  favicon(state) {
    return state.branding.faviconSrc
  },
  linkbackUrl(state) {
    return state.branding.linkbackUrl
  },
  guestUserLandingPage(state) {
    return state.branding.guestUserLandingPage
  },
  supportPortalBackground(state) {
    if (state.branding.supportPortalBackground) {
      return buildImageUrlFromRefFileName(
        state.branding.supportPortalBackground.refFileName
      )
    }
  },
  productSetupGuideBackground(state) {
    if (state.branding.productSetupGuideBackground) {
      return buildImageUrlFromRefFileName(
        state.branding.productSetupGuideBackground.refFileName
      )
    }
  },
  helpViewIconForRequester(state) {
    if (state.branding.helpViewIconForRequester) {
      return buildImageUrlFromRefFileName(
        state.branding.helpViewIconForRequester.refFileName
      )
    }
  },
  helpViewIconForRequesterSrc(state) {
    return state.branding.helpViewIconForRequesterSrc
  },
  helpViewIconForTechnician(state) {
    if (state.branding.helpViewIconForTechnician) {
      return buildImageUrlFromRefFileName(
        state.branding.helpViewIconForTechnician.refFileName
      )
    }
  },
  helpViewIconForTechnicianSrc(state) {
    return state.branding.helpViewIconForTechnicianSrc
  },
}

export const mutations = {
  SET_BRANDING(state, payload) {
    state.branding = payload
    saveState('branding', payload)
  },
}

export const actions = {
  init({ dispatch }) {
    dispatch('fetch')
  },

  fetch({ commit }, params) {
    return getBrandingApi(params).then((data) => {
      commit('SET_BRANDING', data)
      return Promise.resolve(data)
    })
  },

  updateBranding({ commit }, payload) {
    commit(
      'SET_BRANDING',
      Omit(payload.payload, [
        'logoSrc',
        'darkThemeLogoSrc',
        'faviconSrc',
        'helpViewIconForRequesterSrc',
        'helpViewIconForTechnicianSrc',
      ])
    )
    return updateBrandingApi(payload).then((data) => {
      commit('SET_BRANDING', data)
    })
  },

  /**
   * destroy all states when user is logged out
   */
  destroy({ commit }) {
    // commit('SET_BRANDING', {})
  },
}

export function getSavedState(key) {
  if (window.localStorage.getItem(key)) {
    try {
      return JSON.parse(getDecryptedPassword(window.localStorage.getItem(key)))
    } catch (error) {
      return null
    }
  }
  return ''
}

function saveState(key, state) {
  window.localStorage.setItem(key, getEncryptedPassword(JSON.stringify(state)))
}
